<template>
	<div class="display-flex flex-direction-row pb-100 align-items-center justify-items-center">
		<Avatar avatar-size="small" />
		<span class="display-flex flex-direction-column align-items-flex-start ml-50 delta">
			<p class="heading-6">{{ name }}</p>
		</span>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import AdvisorAuthenticatedNav from '@classes/AdvisorAuthenticatedNav';
import AuthenticatedNav from '@classes/AuthenticatedNav';
import Avatar from '@components/avatar/avatar-component.vue';

interface Props {
	nav?: AuthenticatedNav | AdvisorAuthenticatedNav;
}
const props = withDefaults(defineProps<Props>(), {
	nav: undefined
});

const name = computed((): string => {
	if (props.nav && props.nav.fullName) {
		return props.nav.fullName;
	} else {
		return 'Your Account';
	}
});
</script>
